export function formatCurrency(amount, currency = 'USD', locale = 'en') {
  const value = Number(amount) || 0
  if (currency === 'IDR') {
    return new Intl.NumberFormat('id-ID', {
      style: 'currency',
      currency: 'IDR',
      maximumFractionDigits: 0,
    }).format(value)
  }
  const intlLocale = locale === 'id' ? 'id-ID' : 'en-US'
  return new Intl.NumberFormat(intlLocale, {
    style: 'currency',
    currency: 'USD',
  }).format(value)
}

export function planPrimaryAmount(plan, currency) {
  if (!plan) return 0
  if (currency === 'IDR' && plan.price_idr > 0) return plan.price_idr
  return plan.price || 0
}

export function planSecondaryAmount(plan, currency) {
  if (!plan || !plan.price) return 0
  if (currency === 'IDR') return plan.price
  if (plan.price_idr > 0) return plan.price_idr
  return 0
}

export function planSecondaryCurrency(currency) {
  return currency === 'IDR' ? 'USD' : 'IDR'
}
